<template>
  <div>
    <h1 class="mb-4">
      {{ data.title }}
    </h1>
    <FaqItem
      v-for="faq in data.faqs"
      :key="faq.id"
      :question="faq.question"
      :answer="faq.answer"
    />
  </div>
</template>

<script>
import FaqItem from '@/components/products/FaqItem.vue';

export default {
  name: 'StudioFaqPreview',
  components: {
    FaqItem,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
